import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// Removed Ant Design imports
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// Added CB component imports
import { ReactComponent as GoogleLogo } from '../../../images/svg/google-logo.svg';
import { useGlobalState } from '../../../store';
import { accountIconMap } from '../../../utils/customIcons';
import { useLocalization } from '../../../localization'
import {
  CBAlert, CBButton,
  CBHeader,
  CBList,
  CBListItem
} from '../../core/components/cbd';
import { CBDropdown, CBMenu, CBMenuItem } from '../../core/components/CBDropdown';
import { CBSpin } from '../../core/components/CBSpin';
import { CBModal } from '../../core/components/CBModal';


import { API } from 'aws-amplify';

import { ReactComponent as Add } from '../../../images/svg/plus.svg';

import { ReactComponent as More } from '../../../images/svg/menu-more-horizontal.svg';

const AccountItem = ({ item, setShowError }) => {
  const { t } = useLocalization();
  const [showCalendars, setShowCalendars] = useState(false)
  // State for delete confirmation modal
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  // Handler for delete confirmation
  const handleDeleteConfirm = async () => {
    setShowDeleteModal(false); // Close modal
    deleteAccount(); // Call existing delete logic
  };

  // Function to show modal
  function showDeleteConfirm() {
    setShowDeleteModal(true);
  }

  const deleteAccount = () => {
    API.del('account', '/account?id=' + item.calendarAccountId, {
      body: {},
    })
      .then(async () => {
        // const accounts = await loadAccounts()
        // setAccounts(accounts)
        // alert('ok!')
        // window.location.reload()
        window.location.href = window.location.origin + '/dashboard/accounts/'
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'dashboardEvent',
          category: 'userActivity',
          action: 'deleteAccount',
          label: item.ownerId,
          email: item.email,
        })
      })
      .catch((error) => {
        const errorMsg = error.response?.data?.message || 'An error occurred deleting the account.';
        // Replaced message.error with alert() and setShowError
        // alert(errorMsg); // Optionally keep alert
        setShowError(errorMsg);
      })
  }

  const redirectToService = async (redirectUri) => {
    window.location.href = redirectUri
  }

  const reauth = () => {
    API.del('account', '/account?unhook=true&id=' + item.calendarAccountId, {
      body: {},
    })
      .then(async () => {
        //const accounts = await loadAccounts()
        // console.log(item)
        if (item.calendarAccountType == 'ms') {
          if (item.msType == 'gcc') {
            redirectToService(
              `https://login.microsoftonline.us/common/oauth2/v2.0/authorize?prompt=login&client_id=${
                process.env.REACT_APP_OAUTH_O365_CLIENT_GCC
              }&response_type=code&scope=offline_access+Calendars.ReadWrite+User.Read&state=gcc&redirect_uri=${
                process.env.REACT_APP_OAUTH_REDIRECT_URL + process.env.REACT_APP_OAUTH_O365_URL
              }`
            )
          } else {
            redirectToService(
              `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?prompt=login&client_id=${
                process.env.REACT_APP_OAUTH_O365_CLIENT
              }&response_type=code&scope=offline_access+Calendars.ReadWrite+User.Read&state=normal&redirect_uri=${
                process.env.REACT_APP_OAUTH_REDIRECT_URL + process.env.REACT_APP_OAUTH_O365_URL
              }`
            )
          }
        } else if(item.calendarAccountType == 'caldav'){
          redirectToService("/dashboard/accounts/new?caldav=" + encodeURIComponent(item.email))

        } else {
          redirectToService(
            `https://accounts.google.com/o/oauth2/v2/auth?client_id=${
              process.env.REACT_APP_OAUTH_GOOGLE_CLIENT
            }&login_hint=${item.email}&redirect_uri=${
              process.env.REACT_APP_OAUTH_REDIRECT_URL + process.env.REACT_APP_OAUTH_GOOGLE_URL
            }&response_type=code&prompt=login&scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.email+https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.profile+https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fcalendar.events+https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fcalendar.readonly&access_type=offline`
          )
        }
      })
      .catch((error) => {
        // Replaced message.error with alert()
        alert(error.response?.data?.message || 'An error occurred during re-authentication setup.');
      })
  }
  const handleClick = (e) => {
    console.log(e)
    if (e === '0') {
      // showForceDeleteConfirm()
      reauth()
    } else if (e === '1') {
      // showDeleteConfirm()
      
      showDeleteConfirm()
    } else if (e === '2') {
      // showEditConfirm()
    } else if (e === '3') {
      // navigate(`/dashboard/syncs/${item.id.replace('#', '___')}/edit`)
    }
  }

  // Replaced Ant Menu with CBMenu/CBMenuItem
  const menuItems = (
    <CBMenu onClick={({ key }) => handleClick(key)}> {/* Pass key directly */}
      <CBMenuItem key="0">
        <div className="flex gap-x-2 items-center"> {/* Reduced gap */}
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5"> {/* Smaller icon */}
            <path strokeLinecap="round" strokeLinejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
          </svg>{' '}
          {t('scheduler.selectList.accountItem.reAuth')}
        </div>
      </CBMenuItem>
      <CBMenuItem key="1" className="text-red-600"> {/* Added text color */}
        <div className="flex gap-x-2 items-center"> {/* Reduced gap */}
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5"> {/* Smaller icon */}
            <path strokeLinecap="round" strokeLinejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
          </svg>
          {t('scheduler.selectList.accountItem.delete')}
        </div>
      </CBMenuItem>
      {/* Commented out items remain */}
    </CBMenu>
  );


  return (
    <>
      <div className="rounded-sm border-2 border-neutral_1 mt-2 mb-6 flex flex-col shadow-sm">
        <div className="flex flex-col pl-4 pr-4 pb-4">
          <div>
            <CBHeader
              label={<div className="text-sm lg:text-lg">{item.email}</div>}
              icon={
                item.calendarAccountType == 'google' ? (
                  <GoogleLogo></GoogleLogo>
                ) : (
                  <FontAwesomeIcon
                    icon={accountIconMap[item.calendarAccountType].icon}
                    size="2x"
                    color={accountIconMap[item.calendarAccountType].color}
                  />
                )
              }
              menu={
                <div className="flex-grow">
                  {/* Replaced Dropdown with CBDropdown */}
                  <CBDropdown overlay={menuItems} trigger={['click']} placement="bottomRight">
                    {/* Replaced Button with CBButton */}
                    <CBButton type="ternary" icon={<More />} size="large" />
                  </CBDropdown>
                </div>
              }
            ></CBHeader>
          </div>
          {item.errorState != '' && item.errorState != 'Personal' && (
            // Replaced Alert with CBAlert
            <CBAlert
              message={t('scheduler.selectList.accountItem.authIssueAlert')}
              variant="error" // Map type
              showIcon // Assuming CBAlert handles icon based on variant
              className="mt-2" // Added margin
            />
          )}
          {item.errorState != '' && item.errorState == 'Personal' && (
            <a
              href="https://help.calendarbridge.com/doc/sync-troubleshooting/microsoft-plan-and-account-types/"
              target="_blank"
            >
              <Alert
                message={t('scheduler.selectList.accountItem.msftPersonalAlert')}
                type="error"
                showIcon
                
              ></Alert>
            </a>
          )}
        </div>
        <div className="bg-neutral_1 p-4 flex flex-col justify-center">
          <CBListItem
            onClick={(e) => setShowCalendars(!showCalendars)}
            border={false}
            icon={
              <div className="rounded-full flex flex-row gap-x-2 items-center justify-center pt-2 pb-2 pl-4 pr-4 bg-white">
                {item.calendars.length}{' '}
                {showCalendars ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-6 h-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-6 h-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M8.25 4.5l7.5 7.5-7.5 7.5"
                    />
                  </svg>
                )}
              </div>
            }
          >
            {t('scheduler.selectList.accountItem.calendars')}
          </CBListItem>
          {showCalendars && (
            <CBList>
              {item.calendars.map((e) => {
                return <CBListItem key={e.id}>{e.name || e.summary}</CBListItem>
              })}
            </CBList>
          )}
        </div>
      </div>
      <CBModal
        title={t('accounts.deleteModal_title')}
        visible={showDeleteModal}
        onPositiveClick={handleDeleteConfirm}
        onCancelClick={() => setShowDeleteModal(false)}
        positiveLabel={t('common.delete_button')}
        okButtonProps={{ danger: true }} // Assuming CBModal supports this or passes it down
        cancelText={t('common.cancel_button')}
      > 
        <p>{t('accounts.deleteModal_confirmMessage', { email: item.email })}</p>
      </CBModal>
    </>
  )
}
const AccountSelectList = () => {
  const { t } = useLocalization(); // Initialize localization hook for AccountSelectList
  const navigate = useNavigate();
  const [accounts] = useGlobalState('accounts')
  const [loadingCoreData] = useGlobalState('loadingCoreData')
  const [showError,setShowError] = useState("")
  if (loadingCoreData) {
    return (
      <div className="min-h-screen flex items-center justify-center"> {/* Centering */}
        {/* Replaced Spin with CBSpin */}
        <CBSpin
          spinning={true}
          size="large" // Corresponds roughly to fontSize: '100px'
          
        />
      </div>
    )
  }

  const renderItem = (item) => {
    return <AccountItem key={item.calendarAccountId} item={item} setShowError={setShowError}></AccountItem>
  }

  const renderCreate = () => (
    <div className="mt-2 mb-8">
      <CBButton
        onClick={(e) => navigate('/dashboard/accounts/new')}
        long={true}
        icon={<Add></Add>}
      >
        {t('accounts.selectList.addAccountButton')}
      </CBButton>
    </div>
  )

  const list = accounts
    .sort((a, b) => {
      var nameB = b.email
      var nameA = a.email
      if (nameA < nameB)
        //sort string ascending
        return -1
      if (nameA > nameB) return 1
      return 0
    })
    .sort((a, b) => (b.errorState == '' ? 0 : 1) - (a.errorState == '' ? 0 : 1))
    .map(renderItem)

  return (
    <>
    {showError != "" && <div className="p-4 border bg-red-500 text-white">{showError}</div>}
      {renderCreate()}
      <div style={{ maxWidth: 800, minHeight: 1200, margin: '0 auto' }}>
        {list}
        {list.length == 0 && (
          <div className="p-4 padding bg-neutral_0 border text-center"
          
          >{t('accounts.selectList.noAccounts')}</div>
          
        )}
      </div>
    </>
  )
}

export default AccountSelectList
